import * as ValidateModel from '../../shared/ValidateModel';
import { DEV_URL } from '../../const/const';
import { isLocalhost } from '../../store/ApiEndpoints';

class Graphic {
    readonly id: number;

    readonly name: string;

    readonly description: string;

    readonly mime: string;

    readonly source: string;

    readonly width: number;

    readonly height: number;

    readonly fixedWidth: number;

    readonly fixedHeight: number;

    readonly price: number;

    readonly priceRepeatApply: boolean;

    readonly size: number;

    readonly customers: boolean;

    readonly dateUpd: string;

    constructor(
        id: number,
        name: string,
        description: string,
        mime: string,
        source: string,
        width: number,
        height: number,
        fixedWidth: number,
        fixedHeight: number,
        price: number,
        priceRepeatApply: boolean,
        size: number,
        customers: boolean,
        dateUpd: string
    ) {
        ValidateModel.isNumber(id, 'id');
        ValidateModel.isString(name, 'name');
        ValidateModel.isString(description, 'description');
        ValidateModel.isString(mime, 'mime');
        ValidateModel.isString(source, 'source');
        ValidateModel.isNumber(width, 'width');
        ValidateModel.isNumber(height, 'height');
        ValidateModel.isNumber(fixedWidth, 'fixedWidth');
        ValidateModel.isNumber(fixedHeight, 'fixedHeight');
        ValidateModel.isFloat(price, 'price');
        ValidateModel.isBoolean(priceRepeatApply, 'priceRepeatApply');
        ValidateModel.isNumber(size, 'size');
        ValidateModel.isBoolean(customers, 'customers');
        ValidateModel.isString(dateUpd, 'dateUpd');

        this.id = id;
        this.name = name;
        this.description = description;
        this.mime = mime;
        this.source = source;
        this.width = width;
        this.height = height;
        this.fixedWidth = fixedWidth;
        this.fixedHeight = fixedHeight;
        this.price = price;
        this.priceRepeatApply = priceRepeatApply;
        this.size = size;
        this.customers = customers;
        this.dateUpd = dateUpd;
    }

    getId = (): number => this.id;

    getName = (): string => this.name;

    getDescription = (): string => this.description;

    getMime = (): string => this.mime;

    getSource = (): string => this.source;

    getWidth = (): number => this.width;

    getHeight = (): number => this.height;

    getFixedWidth = (): number => this.fixedWidth;

    getFixedHeight = (): number => this.fixedHeight;

    getPrice = (): number => this.price;

    getPriceRepeatApply = (): boolean => this.priceRepeatApply;

    getSize = (): number => this.size;

    getCustomers = (): boolean => this.customers;

    getNameOrSource = (): string => (this.name ? this.name : this.source);

    getSmallImageUrl = (): string =>
        (isLocalhost ? DEV_URL : '') +
        '/image.php?type=graphic&source=small&id_graphic=' +
        this.id +
        '&ts=' +
        new Date(this.dateUpd).getTime();

    getBigImageUrl = (): string =>
        (isLocalhost ? DEV_URL : '') +
        '/image.php?type=graphic&source=big&id_graphic=' +
        this.id +
        '&ts=' +
        new Date(this.dateUpd).getTime();

    getSvgSrc = (): string =>
        (isLocalhost ? DEV_URL : '') +
        '/image.php?type=graphic&ext=svg&id_graphic=' +
        this.id +
        '&ts=' +
        new Date(this.dateUpd).getTime();
}

export default Graphic;
